/* Namie pre-checkout nudge. On checkout click, if the cart is under the
   free-shipping / free-gift threshold, shows a modal with tiered cross-sell
   cards (add-ons, the other room, related). Chooser dropdowns for pump (sets)
   and label (spray/oil). Uses the cart's cc-prog bar. Click-to-zoom images.
   X and Continue both proceed to checkout; backdrop/Esc just close. 24h cap. */
(function () {
  'use strict';
  if (window.__nmPC) return;
  window.__nmPC = true;

  var TESTING = false;                // 24h cap active
  var CAP_KEY = 'nm_pc_seen';
  var CAP_MS = 24 * 60 * 60 * 1000;
  var productCache = {};

  function money(c){ var p=Math.round(c)/100, s=Math.round(p*100)/100; return '£'+(Number.isInteger(s)?s:s.toFixed(2)); }
  function capActive(){ if(TESTING) return false; try{var t=parseInt(localStorage.getItem(CAP_KEY)||'0',10);return t&&(Date.now()-t)<CAP_MS;}catch(e){return false;} }
  function setCap(){ if(TESTING) return; try{localStorage.setItem(CAP_KEY,String(Date.now()));}catch(e){} }
  function cfg(){ var el=document.querySelector('[data-precheckout-config]'); if(!el) return null; try{return JSON.parse(el.textContent);}catch(e){return null;} }

  function freshConfig(){
    var cf = document.querySelector('cart-form[data-section-id]');
    var sid = cf ? cf.getAttribute('data-section-id') : 'cart-drawer';
    return fetch('/?section_id=' + encodeURIComponent(sid), { headers:{ Accept:'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(html){ var m=html.match(/data-precheckout-config>([\s\S]*?)<\/script>/); if(m){try{return JSON.parse(m[1].trim());}catch(e){}} return cfg(); })
      .catch(function(){ return cfg(); });
  }

  function tierOf(title){
    if (/robe hook|towel|shower shelf|soap dish|toilet roll|toilet brush|tumbler|toothbrush|bath caddy|bathroom set|4-piece/i.test(title)) return 'fixture';
    if (/wall bracket/i.test(title) && (/&/.test(title) || !state.hasDispenser)) return 'fixture';   // bracket+dispenser sets always; standalone brackets only when no dispenser in cart (else a finishing touch)
    if (/tray|funnel|grip|wall bracket|dish brush/i.test(title)) return 'addon';
    if (/oil|vinegar|storage jar|tea coffee|spray|spice|lazy susan/i.test(title)) return 'related';   // oil / jar / spray sets pair well, they are not a room set
    if (/\bset\b/i.test(title)) return 'set';
    return 'related';
  }
  function roomOf(title){ return /dish soap/i.test(title) ? 'kitchen' : 'bathroom'; }
  function setType(t){ t=t||''; if(/dish soap/i.test(t)) return 'DG'; if(/hand cream/i.test(t)) return 'DH'; if(/body wash|shampoo|conditioner/i.test(t)) return 'ABC'; return null; }

  var overlay, modal, body, progEl, zoomEl, zoomImg, zoomThumb, checkoutHref = '/checkout';
  var state = {};

  function finalThreshold(){ return (state.giftOn && state.gift>0) ? Math.max(state.threshold, state.gift) : state.threshold; }

  function msgText(){
    if (state.total < state.threshold) return "You're only " + money(state.threshold - state.total) + " away from free delivery";
    if (state.giftOn && state.gift>0 && state.total < state.gift) return "You're only " + money(state.gift - state.total) + " from a free gift";
    return state.giftOn ? "Free delivery & free gift unlocked" : "Free delivery unlocked";
  }

  function renderProg(){
    var final = finalThreshold();
    var progress = final ? Math.min(1, state.total/final) : 0;
    var col = progress >= 1 ? state.colMet : state.colUnder;
    var shipPos = (state.giftOn && state.gift>0) ? (state.threshold/final*100) : 100;
    var h = '<div class="cc-prog" style="--cc-progress:'+progress+'; --cc-col:'+col+';">'
      + '<div class="cc-prog__msg">'+msgText()+'</div>'
      + '<div class="cc-prog__track"><div class="cc-prog__fill"></div><div class="cc-prog__markers">'
      + '<span class="cc-prog__dot'+(state.total>=state.threshold?' is-met':'')+'" style="left:'+shipPos+'%;"></span>'
      + '<span class="cc-prog__label" style="left:'+shipPos+'%;">'+state.shipLabel+'</span>';
    if (state.giftOn && state.gift>0) h += '<span class="cc-prog__dot'+(state.total>=state.gift?' is-met':'')+'" style="left:100%;"></span><span class="cc-prog__label" style="left:100%;">'+state.giftLabel+'</span>';
    h += '</div></div></div>';
    progEl.innerHTML = h;
  }

  function render(){
    renderProg();
    body.innerHTML = '';
    var tiers = { addon:[], set:[], fixture:[], related:[] };
    state.items.forEach(function(it){ tiers[tierOf(it.title)].push(it); });
    // base order = cart order; pin trays to the top of tier 1 (high conversion). Stable sort keeps the rest in cart order.
    tiers.addon.sort(function(a,b){ return (/tray/i.test(a.title)?0:1) - (/tray/i.test(b.title)?0:1); });
    function heading(txt){ var h=document.createElement('div'); h.className='nm-pc-tier'; h.textContent=txt; body.appendChild(h); }
    function rows(arr){ arr.forEach(function(it){ body.appendChild(row(it)); }); }
    if (tiers.addon.length){ heading('Finishing touches'); rows(tiers.addon); }
    // tier 2: split into kitchen / bathroom, each with its own heading, in first-appearance order
    var roomOrder=[], roomItems={kitchen:[],bathroom:[]};
    tiers.set.forEach(function(it){ var r=roomOf(it.title); if(roomOrder.indexOf(r)===-1) roomOrder.push(r); roomItems[r].push(it); });
    roomOrder.forEach(function(r){ heading(r==='kitchen'?'For your kitchen':'For your bathroom'); rows(roomItems[r]); });
    if (tiers.fixture.length){ heading('Matching accessories'); rows(tiers.fixture); }
    if (tiers.related.length){ heading('Pairs well with'); rows(tiers.related); }
    if (!state.items.length){ heading('Nothing else to add'); }
  }

  function pickChooser(optionNames){
    // Pump colour is never a chooser: the referenced variant already matches the pump/lid in the cart.
    var li=null; optionNames.forEach(function(n){ if(!li && /label/i.test(n)) li=n; });
    if (li) return { name:li, label:'Label' };
    return null;
  }
  function fetchProduct(handle){
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/'+handle+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(p){
      var names=p.options.map(function(o){return o.name||o;});
      var out={optionNames:names, variants:p.variants.map(function(v){return {id:v.id,sku:v.sku,available:v.available,options:v.options,image:(v.featured_image&&v.featured_image.src)||null};})};
      productCache[handle]=out; return out;
    }).catch(function(){return {optionNames:[],variants:[]};});
  }

  function row(it){
    var el=document.createElement('div'); el.className='nm-pc-item';
    el.innerHTML = (it.image?'<img class="nm-pc-item__img" src="'+it.image+'" alt="">':'<span class="nm-pc-item__img"></span>')
      + '<div class="nm-pc-item__info"><div class="nm-pc-item__title">'+it.title+'</div>'
      + '<div class="nm-pc-item__price">'+money(it.price)+'</div>'
      + '<div class="nm-pc-choose" data-pc-choose hidden></div></div>'
      + '<button class="nm-pc-add" data-pc-add>Add</button>';
    var imgEl = el.querySelector('.nm-pc-item__img');
    if (imgEl && it.image) imgEl.addEventListener('click', function(){ openZoom(imgEl, imgEl.getAttribute('src')); });
    var addBtn = el.querySelector('[data-pc-add]');
    if (!it.hasVariants) { addBtn.addEventListener('click', function(){ add(it.variantId, addBtn, it.sku); }); return el; }

    addBtn.disabled = true;
    fetchProduct(it.handle).then(function(p){
      var ch = pickChooser(p.optionNames);
      if (!ch) { addBtn.disabled=false; addBtn.addEventListener('click', function(){ add(it.variantId, addBtn, it.sku); }); return; }
      var oi=p.optionNames.indexOf(ch.name);
      var pool=p.variants.filter(function(v){return v.available;});
      var sv=p.variants.find(function(v){return v.id===it.variantId;});
      if (sv){ var locked=pool.filter(function(v){ return v.options.every(function(x,i){ return i===oi || x===sv.options[i]; }); }); if (locked.length) pool=locked; }   // lock every other option (lid/pump/add-on) to the referenced variant
      var seen={}, opts=[];
      pool.forEach(function(v){ var val=v.options[oi]; if(val && !seen[val]){ seen[val]=1; opts.push({val:val,id:v.id,image:v.image,sku:v.sku}); } });
      if (!opts.length){ addBtn.disabled=false; addBtn.addEventListener('click', function(){ add(it.variantId, addBtn, it.sku); }); return; }
      var wrap=el.querySelector('[data-pc-choose]');
      wrap.innerHTML='<span class="nm-pc-choose__lbl">'+ch.label+':</span><select class="nm-pc-item__sel"></select>';
      var sel=wrap.querySelector('select');
      opts.forEach(function(o){ var op=document.createElement('option'); op.value=o.id; op.textContent=o.val; sel.appendChild(op); });

      if (sv){ var match=opts.find(function(o){return o.val===sv.options[oi];}); if(match) sel.value=match.id; }
      if (it.title.length > 42) el.classList.add('nm-pc-item--tight');   // long title + dropdown -> smaller title to fit 2 lines
      var withW=function(s){ return s ? (s + (s.indexOf('?')>-1?'&':'?') + 'width=800') : s; };
      sel.addEventListener('change', function(){ var o=opts.find(function(x){return String(x.id)===sel.value;}); if(o && o.image && imgEl){ imgEl.src=withW(o.image); } });
      wrap.hidden=false; addBtn.disabled=false;
      addBtn.addEventListener('click', function(){ var o=opts.find(function(x){return String(x.id)===sel.value;}); add(parseInt(sel.value,10), addBtn, o&&o.sku); });
    });
    return el;
  }

  function reduced(){ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function flipTransform(thumb){
    var last=zoomImg.getBoundingClientRect(), first=thumb.getBoundingClientRect();
    if(!last.width||!first.width) return null;
    var sx=first.width/last.width, sy=first.height/last.height;
    var tx=(first.left+first.width/2)-(last.left+last.width/2);
    var ty=(first.top+first.height/2)-(last.top+last.height/2);
    return 'translate('+tx+'px,'+ty+'px) scale('+sx+','+sy+')';
  }
  function openZoom(thumb, src){
    if(!zoomEl) return; zoomThumb=thumb; zoomImg.src=src;
    var go=function(){
      zoomEl.hidden=false;
      requestAnimationFrame(function(){
        zoomEl.classList.add('is-open');                 // backdrop fades in
        var t=flipTransform(thumb);
        if(!t || reduced()){ zoomImg.style.transform='none'; return; }
        zoomImg.style.transition='none'; zoomImg.style.transform=t;   // start at the thumbnail
        requestAnimationFrame(function(){ zoomImg.style.transition='transform .28s ease'; zoomImg.style.transform='none'; }); // grow to full
      });
    };
    if (zoomImg.complete && zoomImg.naturalWidth) go(); else zoomImg.onload=go;
  }
  function hideZoomNow(){ zoomEl.hidden=true; zoomEl.classList.remove('is-open'); zoomImg.style.transition='none'; zoomImg.style.transform='none'; }
  function closeZoom(instant){
    if(!zoomEl || zoomEl.hidden) return;
    if(instant || reduced() || !zoomThumb){ hideZoomNow(); return; }
    var t=flipTransform(zoomThumb);
    zoomEl.classList.remove('is-open');
    if(!t){ hideZoomNow(); return; }
    zoomImg.style.transition='transform .28s ease';
    requestAnimationFrame(function(){ zoomImg.style.transform=t; });   // shrink back to the thumbnail
    var done=function(e){ if(e&&e.target!==zoomImg)return; hideZoomNow(); zoomImg.removeEventListener('transitionend',done); };
    zoomImg.addEventListener('transitionend',done);
  }

  function add(variantId, btn, sku){
    if (!variantId) return;
    btn.disabled=true; btn.textContent='Adding...';
    var item = { id:variantId, quantity:1 };
    if (sku) item.properties = { _pc_crosssell: sku };   // -> order tag "PC cross-sell <SKU>" via Flow
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(){ return fetch('/cart.js',{headers:{Accept:'application/json'}}); })
      .then(function(r){return r.json();})
      .then(function(cart){
        state.total=cart.total_price;
        var ids=cart.items.map(function(i){return i.id;});
        state.items=state.items.filter(function(it){ return ids.indexOf(it.variantId)===-1; });
        render();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      })
      .catch(function(){ btn.disabled=false; btn.textContent='Add'; });
  }

  function open(){ overlay.hidden=false; requestAnimationFrame(function(){overlay.classList.add('is-open');}); document.addEventListener('keydown',onKey,true); overlay.addEventListener('mousedown',onBackdrop); }
  function close(go){ setCap(); closeZoom(); overlay.classList.remove('is-open'); document.removeEventListener('keydown',onKey,true); overlay.removeEventListener('mousedown',onBackdrop);
    var done=function(){ overlay.hidden=true; overlay.removeEventListener('transitionend',done); if(go) window.location.href=checkoutHref; };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else overlay.addEventListener('transitionend',done);
  }
  function onBackdrop(e){ if(e.target===overlay) close(false); }
  function onKey(e){ if(e.key==='Escape'){e.preventDefault(); if(zoomEl && !zoomEl.hidden){closeZoom(false);return;} close(false);} }

  document.addEventListener('click', function(e){
    var link = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
    if (!link) return;
    if (capActive()) return;
    var href = (link.tagName==='A' && link.href) ? link.href : '/checkout';
    e.preventDefault(); e.stopImmediatePropagation();
    Promise.all([
      freshConfig(),
      fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).catch(function(){return {items:[]};})
    ]).then(function(res){
      var c = res[0], cart = res[1] || {items:[]};
      if (!c || !c.items || !c.items.length) { window.location.href=href; return; }
      var final = (c.giftEnabled && c.giftThreshold>0) ? Math.max(c.threshold, c.giftThreshold) : c.threshold;
      if (c.cartTotal >= final) { window.location.href=href; return; }
      // drop set types already in the cart; keep missing types once per cart glass colour (cart order)
      var owned={}; (cart.items||[]).forEach(function(i){ var t=setType(i.title||i.product_title); if(t) owned[t]=1; });
      var hasDisp=false; (cart.items||[]).forEach(function(i){ if(/dispenser/i.test(i.product_title||i.title||'')) hasDisp=true; });
      c.items = c.items.filter(function(it){ var t=setType(it.title); return !t || !owned[t]; });
      if (!c.items.length) { window.location.href=href; return; }
      checkoutHref = href;
      overlay = document.querySelector('[data-pc-overlay]'); if(!overlay){ window.location.href=href; return; }
      modal=overlay.querySelector('.nm-pc-modal');
      body=overlay.querySelector('[data-pc-body]'); progEl=overlay.querySelector('[data-pc-prog]');
      zoomEl=overlay.querySelector('[data-pc-zoom]'); zoomImg=overlay.querySelector('[data-pc-zoomimg]');
      if (zoomEl) zoomEl.onclick=function(){ closeZoom(false); };
      state = { hasDispenser:hasDisp, total:c.cartTotal, threshold:c.threshold, gift:c.giftThreshold, giftOn:!!c.giftEnabled, items:c.items.slice(),
                shipLabel:c.shipLabel||'Free delivery', giftLabel:c.giftLabel||'Free gift', colUnder:c.colUnder||'#3b6d11', colMet:c.colMet||'#3b6d11' };
      render(); open();
      overlay.querySelector('[data-pc-close]').onclick=function(){
        if (zoomEl && !zoomEl.hidden) { closeZoom(true); }   // zoom open: X just closes the image instantly
        else { close(true); }                                // otherwise X = decline but go to checkout
      };
      overlay.querySelector('[data-pc-continue]').onclick=function(){ close(true); };
    }).catch(function(){ window.location.href=href; });
  }, true);
})();
